import { toCurrency } from "@/shared/helpers";

export const RECLAIM_POINTS_COLUMNS = [
    {
        Header: "First Name",
        accessor: "first_name",
    },
    {
        Header: "Last Name",
        accessor: "last_name",
    },
    {
        Header: "Email",
        accessor: "user_email",
    },
    {
        Header: "Awarded Date",
        accessor: "awarded",
    },
    {
        Header: "Event Name",
        accessor: "event_name"
    },
    {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ row, value }) => toCurrency(value),
        width: 120
    },
    {
        Header: "Notes",
        accessor: "notes"
    },
]